<main>
  <app-navbar />
  <section class='container'>
    <router-outlet></router-outlet>
  </section>
</main>